import { createElement as rc } from 'react';
import PropTypes from 'prop-types';
import { testProperties, Tooltip, FeedbackIcon } from 'lib_ui-primitives';

/**
 * @typedef {Object} Props
 * @property {Object} hNode
 * @property {string} currentRoute
 */
/** @type {import('react').FC<Props>} */
function InfoDisplayButton(props) {
    const {
        hNode: { id, title: _title = '', message: _body = '', icon = 'info', defaultOpen = false }
    } = props;

    let title = _title;
    let body = _body;
    if (!_title && !_body) {
        return null;
    } else if (!_title) {
        title = body;
        body = '';
    }

    // prettier-ignore
    return rc(Tooltip, {  id, title, body, defaultOpen },
        rc(FeedbackIcon, {
            ...testProperties(props.hNode, 'toggleButton'),
            name: icon,
            color: 'primary',
            variant: 'secondary',
            size: 'xs'
        })
    );
}

InfoDisplayButton.defaultProps = {};

InfoDisplayButton.propTypes = {
    hNode: PropTypes.object.isRequired,
    currentRoute: PropTypes.string.isRequired
};

export default InfoDisplayButton;
